<template>
    <ul class="nav-tab">
        <router-link v-for="(item, index) in linkArr"
                     :key="index"
                     :to="item.to"
                     tag="li"
                     replace>
            {{item.text}}
        </router-link>
    </ul>
</template>

<script>
    export default {
        name: 'NavTab',
        components: {
        },
        props: ['linkArr'],
        data() {
            return {
            }
        },
        computed: {
        },
        mounted() {
        },
        methods: {
        }
    }
</script>

<style scoped lang="scss">
    @import "~@/assets/css/theme/theme.scss";
    .nav-tab {
        height: 32px;
        margin: 10px 15px;
        border-radius: 6px;
        border: 1px solid var(--main-color);
        overflow: hidden;
        display: flex;

        li {
            border-right: 1px solid var(--main-color);
            color: var(--main-color);
            flex-grow: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            transition: background-color 0.5s ease-out;
            -webkit-user-select: none;
            user-select: none;
            @extend .font14;

            &:active {
                background-color: #000000;
            }

            &.router-link-active {
                color: #ffffff;
                background: var(--main-color);
            }
        }
        li:last-child {
            border-right: none;
        }
    }
</style>
